/**
 * Normalize an email for submission/comparison: trim surrounding whitespace and
 * lowercase. The backend is the validation authority; this is defense-in-depth and
 * keeps mobile-keyboard casing from leaking into payloads.
 */
export const normalizeEmail = (email: string): string =>
  email.trim().toLowerCase();
